import React from "react";
import { PageHero } from "../components/Sections";
import { Card } from "../components/ui/card";
import { companyInfo } from "../mock/data";
import { useSettings } from "../context/SettingsContext";
import { Building2, ShieldAlert } from "lucide-react";

export default function CompanyInfo() {
  const { settings } = useSettings();
  const fields = [
    { label: "Legal Company Name", value: settings.company_name },
    { label: "Registered Office Address", value: settings.address },
    { label: "CIN", value: settings.cin },
    { label: "GSTIN", value: settings.gstin },
    { label: "Official Email", value: settings.email },
    { label: "Telephone", value: settings.phone },
    { label: "Website", value: settings.website },
    { label: "Customer Support Contact", value: settings.support_contact },
    { label: "Grievance Officer Contact", value: settings.grievance_contact },
    { label: "Applicable Registrations / Licences", value: settings.registrations },
  ];
  return (
    <div>
      <PageHero title="Company & Regulatory Information"
        subtitle={companyInfo.intro} crumbs={[{ label: "Company Information" }]} />
      <section className="section-pad">
        <div className="container-page max-w-3xl">
          <Card className="border p-6 md:p-8">
            <h2 className="font-heading text-xl font-semibold flex items-center gap-2">
              <Building2 className="h-5 w-5 text-primary" /> Company Identity
            </h2>
            <dl className="mt-6 divide-y">
              {fields.map((f) => (
                <div key={f.label} className="grid grid-cols-1 gap-1 py-3.5 sm:grid-cols-3">
                  <dt className="text-sm font-semibold text-muted-foreground">{f.label}</dt>
                  <dd className="text-sm sm:col-span-2">
                    {f.value ? f.value : <span className="text-muted-foreground italic">[To be provided]</span>}
                  </dd>
                </div>
              ))}
            </dl>
          </Card>

          <div className="mt-8 flex items-start gap-3 rounded-xl border border-primary/20 bg-secondary/50 p-4">
            <ShieldAlert className="h-5 w-5 shrink-0 text-primary" />
            <p className="text-sm text-muted-foreground">{companyInfo.note}</p>
          </div>
        </div>
      </section>
    </div>
  );
}
